{
  "en": {
    "ticket_category": {
      "Decisions": "Decision",
      "Issue": "Aftercare",
      "Other": "Regular",
      "labels": {
        "ticket_category": "Type"
      }
    }
  }
}
